import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastContainer.css';

export default function StyledToastContainer() {
  return <ToastContainer />;
}
